import { gql } from '@apollo/client';

const ERRORS = `errors { path, message }`;

const USER_FIELDS = gql`
  fragment McadminUserFields on McadminUser {
    id
    name
    displayName
    emails
    project {
      id
      name
    }
  }
`;

export const USERS = gql`
  ${USER_FIELDS}
  query McadminUsers {
    users: mcadminUsers {
      ...McadminUserFields
    }
    projects: mcadminProjects {
      label: title
      value: id
    }
  }
`;

const USER_ARGUMENTS = `
  $name: String!
  $projectId: ID!
  $displayName: String!
  $password: String!
`;

const USER_VARIABLES = `
  name: $name
  projectId: $projectId
  displayName: $displayName
  password: $password
`;

export const CREATE_USER = gql`
  ${USER_FIELDS}
  mutation CreateMcadminUser (
    ${USER_ARGUMENTS}
  ) {
    createMcadminUser (
      ${USER_VARIABLES}
    ) {
      user {
        ...McadminUserFields
      }
      ${ERRORS}
    }
  }
`;

export const UPDATE_USER = gql`
  ${USER_FIELDS}
  mutation UpdateMcadminUser (
    $id: ID!
    ${USER_ARGUMENTS}
  ) {
    updateMcadminUser (
      id: $id
      ${USER_VARIABLES}
    ) {
      user {
        ...McadminUserFields
      }
      ${ERRORS}
    }
  }
`;

export const DESTROY_USER = gql`
  mutation DestroyMcadminUser ($id: ID!) {
    destroyMcadminUser (id: $id) {
      ${ERRORS}
    }
  }
`;
